import React from 'react';

interface StatCardProps {
  title: string;
  value: number;
  icon: React.ReactNode;
  color?: 'purple' | 'blue' | 'green' | 'pink' | 'orange' | 'indigo' | 'red' | 'teal' | 'gray';
  subtitle?: string;
}

export const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  icon,
  color = 'purple',
  subtitle
}) => {
  const colorClasses = {
    purple: 'from-purple-400 to-purple-600 text-purple-700 bg-purple-50',
    blue: 'from-blue-400 to-blue-600 text-blue-700 bg-blue-50',
    green: 'from-green-400 to-green-600 text-green-700 bg-green-50',
    pink: 'from-pink-400 to-pink-600 text-pink-700 bg-pink-50',
    orange: 'from-orange-400 to-orange-600 text-orange-700 bg-orange-50',
    indigo: 'from-indigo-400 to-indigo-600 text-indigo-700 bg-indigo-50',
    red: 'from-red-400 to-red-600 text-red-700 bg-red-50',
    teal: 'from-teal-400 to-teal-600 text-teal-700 bg-teal-50',
    gray: 'from-gray-400 to-gray-600 text-gray-700 bg-gray-50'
  };

  return (
    <div className={`bg-gradient-to-r ${colorClasses[color].split(' ')[0]} ${colorClasses[color].split(' ')[1]} rounded-lg shadow-sm border border-gray-200 overflow-hidden`}>
      <div className="px-6 py-4 bg-white/90 backdrop-blur-sm">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-xs font-medium text-gray-600">{title}</p>
            <p className="text-xs font-medium text-gray-900 mt-1">{value.toLocaleString()}</p>
            {subtitle && (
              <p className="text-xs text-gray-500 mt-1">{subtitle}</p>
            )}
          </div>
          <div className={`p-3 rounded-full ${colorClasses[color].split(' ')[2]} ${colorClasses[color].split(' ')[3]}`}>
            {icon}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatCard;
